/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import useTranslate from 'hooks/useTranslate';
import Link from 'components/Link';
import useWorkflow, { Step } from 'hooks/useWorkflow';
import CancelButton from 'features/CancelButton';
import { useMarkdownMultilineTranslate } from 'hooks/useTranslate/useTranslate';
import SimpleMessagePage from 'components/SimpleMessagePage';
import SkipPrefillButton from 'features/SkipPrefillButton';

const ExpiredView: React.FC = () => {
  const { pathAfter } = useWorkflow();
  const t = useTranslate();
  const tMdMultiline = useMarkdownMultilineTranslate();

  return (
    <SimpleMessagePage
      headerTitle="batchPrescreen.error.title"
      message={tMdMultiline('batchPrescreen.expired.message')}
    >
      <SkipPrefillButton
        variant="contained"
        id="continueToApplication"
        component={Link}
        to={pathAfter(Step.BATCH_PRESCREEN_START)}
      >
        {t('batchPrescreen.error.continueButton')}
      </SkipPrefillButton>

      <CancelButton />
    </SimpleMessagePage>
  );
};

export default ExpiredView;
